import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";
import { useGetInfiniteScroll } from "../../utils/queries";
import { homeToken } from "../../utils/constant";
import { connectionsApiUrl } from "../../utils/config";
import {
  BniLoaderBox,
  NoRecordsTypography,
} from "./ConnectionsCardsInfiniteScroll.styles";
import BniLoader from "../Loaders/BniLoader";
import ConnectionsCard from "../ConnectionsCard/ConnectionsCard";

export const CONNECTIONS_PAGINATON_MODEL_DEFAULT = {
  page: 0,
  no_of_records: 24,
};

const ConnectionsCardsInfiniteScroll = ({ querykey = "", searchText = "" }) => {
  const { t } = useTranslation();
  const { ref, inView } = useInView();
  const [paginationModel, setPaginationModel] = useState(
    CONNECTIONS_PAGINATON_MODEL_DEFAULT
  );
  const [totalPages, setTotalPages] = useState();

  const generateApiUrl = () => {
    let url = `${connectionsApiUrl}v1?pageNumber=${paginationModel.page}&pageSize=${paginationModel.no_of_records}`;
    let buildUrl =
      searchText === ""
        ? url
        : `${url}&searchContacts=${encodeURI(searchText)}`;
    return { url: buildUrl, data: "" };
  };

  const requestData = generateApiUrl();
  const { data, fetchNextPage, hasNextPage, isFetching, isSuccess, isError } =
    useGetInfiniteScroll(
      querykey,
      requestData.url,
      requestData.data,
      totalPages
    );

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
    if (data) {
      setPaginationModel({ ...paginationModel, page: data.pages.length });
      let totalRecords = data.pages.length
        ? data?.pages[0].content.totalPages
        : 1;
      if (totalRecords > 0) {
        setTotalPages(totalRecords);
      }
    }
  }, [inView, fetchNextPage, hasNextPage]);

  return (
    <>
      {isSuccess &&
        data.pages.map((page, j) => {
          if (page.content.content.length <= 0) {
            return (
              <NoRecordsTypography>
                {t(homeToken.DataNotFound)}
              </NoRecordsTypography>
            );
          } else {
            return page.content.content.map((connectionsCardData, i) => {
              if (page.content.content.length === i + 1) {
                return (
                  <ConnectionsCard
                    cardData={connectionsCardData}
                    key={connectionsCardData.connectionUser}
                    isRef={true}
                    refVal={ref}
                    className="refcard"
                    currentPage={j + 1}
                  />
                );
              } else {
                return (
                  <ConnectionsCard
                    cardData={connectionsCardData}
                    key={connectionsCardData.connectionUser}
                    currentPage={j + 1}
                  />
                );
              }
            });
          }
        })}
      {isFetching && (
        <BniLoaderBox>
          <BniLoader width="inherit" />
        </BniLoaderBox>
      )}

      {isError && (
        <NoRecordsTypography>{t(homeToken.GenericError)}</NoRecordsTypography>
      )}
    </>
  );
};

export default ConnectionsCardsInfiniteScroll;
